import React, { useEffect, useState } from "react";
import styles from "./SignaturePadNew.module.scss";
import { Box, Button, IconButton, Modal } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { LoadingButton } from "@mui/lab";
import Signature from "signature_pad";
import _ from "lodash";
import { isMobile } from "react-device-detect";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { confirmAlert } from "react-confirm-alert";
import { dataURItoFile } from "../../shared/commonfunctions";
import { uploadDocumentsAPICall } from "../../shared/APICalls";
import drawicon from "../../Components/assets/Images/stylus_note.svg";
import SnackBar from "../SnackBars/SnackBar";
import FormatterCheckerSignature from "../../pages/FormatCheckerSignature";

const successModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  boxShadow: 24,
  outline: "none",
  display: "flex",
};

interface props {
  purpose: any;
  documentRef: any;
  setpreviewImageLoading: any;
  documentID: any;
  setDrawPad: any;
  previewImageLoading: any;
  setsignatureUrl: any;
  handlePreview: any;
  formats: any;
  handleSignatureDocumentID: any;
  signatureUrl: any;
  UploadSizes: any;
  selectedFile: any;
  setSelectedFile: any;
}

const SignaturePadNew = ({
  purpose,
  documentRef,
  setpreviewImageLoading,
  documentID,
  setDrawPad,
  previewImageLoading,
  setsignatureUrl,
  handlePreview,
  formats,
  handleSignatureDocumentID,
  signatureUrl,
  UploadSizes,
  selectedFile,
  setSelectedFile,
}: props) => {
  const [signaturePad, setSignaturePad] = useState<any>();
  const [savedSignature, setSavedSignature] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isSigned, setIsSigned] = useState(false);
  let signatureRedoArray: any = [];

  //   console.log("signatureUrl", signatureUrl);

  const readyPad = () => {
    let wrapper = document.getElementById("signature-pad");
    let canvas: any = wrapper?.querySelector("canvas");
    canvas?.getContext && canvas?.getContext("2d")?.scale(1, 1);
    let tempSignaturePad = new Signature(canvas, {
      backgroundColor: "rgb(255, 255, 255)",
    });
    setSignaturePad(tempSignaturePad);
  };

  const handleSave = () => {
    if (signatureUrl) return;
    if (!signaturePad) return;

    if (signaturePad.isEmpty()) {
      confirmAlert({
        title: "",
        message: "Please sign before uploading.",
        buttons: [
          {
            label: "Ok",
            onClick: () => {},
          },
        ],
      });
      return;
    }

    const formData = new FormData();
    const dataURL = signaturePad.toDataURL();
    const file = dataURItoFile(dataURL, "signature.png");

    const obj: any = {
      file: file,
      doc_ref: purpose,
      file_password: "123456",
      doc_purpose: documentRef,
    };

    formData.append("file", obj.file);
    formData.append("doc_ref", obj.doc_ref);
    formData.append("file_password", obj.file_password);
    formData.append("doc_purpose", obj.doc_purpose);
    // console.log("hello");
    setpreviewImageLoading(true);
    uploadDocumentsAPICall(formData)
      .then((response: any) => {
        const responseData = response?.data;
        setpreviewImageLoading(false);
        setsignatureUrl(responseData?.data?.doc_url);
        documentID("Document uploaded successfully.");
        setDrawPad(false);
        handleClear();
      })
      .catch((error: any) => {
        // console.log("error", error)
        setpreviewImageLoading(false);

        setErrorMessage(
          error?.message?.includes("Network")
            ? "Error Uploading, Please try again"
            : error?.response?.data?.message,
        );

        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });

    setSavedSignature(signaturePad.toDataURL());
    console.log("Signature saved!");
  };

  const handleUndo = () => {
    if (signatureUrl) return;
    let signatureRemovedData: any = [];
    let signatureData = signaturePad.toData();
    let signatureRedoData = _.cloneDeep(signatureData);

    if (signatureData.length > 0) {
      signatureData.pop(); // remove the last dot or line
      signaturePad.fromData(signatureData);
      signatureRemovedData = signatureRedoData[signatureRedoData.length - 1];
      signatureRedoArray.push(signatureRemovedData);
    }
  };

  const handleRedo = () => {
    if (signatureUrl) return;
    if (signatureRedoArray.length !== 0) {
      let values = signaturePad.toData();
      let lastValue: any = signatureRedoArray[signatureRedoArray.length - 1];
      values.push(lastValue);
      signaturePad.fromData(values);
      signatureRedoArray.pop(lastValue); //remove the redo item from array
    }
  };

  const handleClear = () => {
    if (signatureUrl) return;
    signaturePad.clear();
  };

  useEffect(() => {
    setTimeout(() => {
      readyPad();
    }, 1000);
  }, []);

  return (
    <div>
      <SnackBar message={errorMessage} />

      <div className={styles.modalWrapper}>
        <div className={styles.signatureSection}>
          <div className={styles.title}>
            <img src={drawicon} /> Use the pad to sign
          </div>
          {isMobile ? (
            <div className={styles.signaturePadMobile}>
              <div id="signature-pad">
                <canvas
                  height={200}
                  style={{
                    border: "1px dashed  #E5E7EB",
                    borderRadius: "16px",
                  }}
                  className="signature-canvas"
                ></canvas>
              </div>
            </div>
          ) : (
            <div className={styles.signaturePadDesktop}>
              <div id="signature-pad">
                <canvas
                  height={217}
                  width={580}
                  style={{
                    border: "1px dashed  #E5E7EB",
                    borderRadius: "16px",
                  }}
                  className="signature-canvas"
                ></canvas>
              </div>
            </div>
          )}

          <div className={styles.tools}>
            <div className={styles.toolsLeft}>
              <Button
                variant="outlined"
                onClick={handleUndo}
                style={{
                  color: "black",
                  border: "1px solid #E5E7EB",
                  background: "#fff",
                  height: "40px",
                  opacity: signatureUrl ? 0.6 : 1,
                  cursor: signatureUrl ? "not-allowed" : "",
                }}
              >
                <RefreshIcon style={{ transform: "scaleX(-1)" }} /> Undo
              </Button>
              {/* <Button
                variant="outlined"
                onClick={handleRedo}
                style={{
                  color: "black",
                  border: "1px solid #E5E7EB",
                  background: "#fff",
                  height: "40px",
                }}
              >
                <RefreshIcon /> Redo
              </Button> */}
              <Button
                variant="outlined"
                onClick={handleClear}
                style={{
                  color: "#DC2626",
                  border: "1px solid #E5E7EB",
                  background: "#fff",
                  height: "40px",
                  opacity: signatureUrl ? 0.6 : 1,
                  cursor: signatureUrl ? "not-allowed" : "",
                }}
              >
                <BorderColorOutlinedIcon /> Clear
              </Button>
              {!isSigned && (
                <div className={styles.toolsLeftuploadMobile}>
                  <FormatterCheckerSignature
                    previewImage={handlePreview}
                    acceptedFormats={formats}
                    documentRef={"signature"}
                    documentID={handleSignatureDocumentID}
                    displayOptions={""}
                    stageDetailsData={signatureUrl}
                    name="signature"
                    purpose={"signature"}
                    pdfSize={UploadSizes["signature"].pdfSize}
                    imageSize={UploadSizes["signature"].imageSize}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                    setsignatureUrl={setsignatureUrl}
                  />
                </div>
              )}
            </div>
            <div className={styles.toolsRight}>
              {!isSigned && (
                <div className={styles.toolsLeftupload}>
                  <FormatterCheckerSignature
                    previewImage={handlePreview}
                    acceptedFormats={formats}
                    documentRef={"signature"}
                    documentID={handleSignatureDocumentID}
                    displayOptions={""}
                    stageDetailsData={signatureUrl}
                    name="signature"
                    purpose={"signature"}
                    pdfSize={UploadSizes["signature"].pdfSize}
                    imageSize={UploadSizes["signature"].imageSize}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                    setsignatureUrl={setsignatureUrl}
                  />
                </div>
              )}

              <LoadingButton
                variant="contained"
                id="upLoadDocumentsContinueButton"
                className={styles.approveButton}
                sx={{
                  height: "40px",
                  background: "#3263E5",
                  width: { xs: "100%", sm: "100px" },
                  opacity: signatureUrl ? 0.6 : 1,
                  cursor: signatureUrl ? "not-allowed" : "",
                  "&:hover": {
                    background: "#3263E5",
                  },
                }}
                onClick={handleSave}
                loading={previewImageLoading}
              >
                Save
              </LoadingButton>
            </div>
          </div>
        </div>

        {/* <div className={styles.buttonSection}>
          <LoadingButton
            variant="contained"
            id="upLoadDocumentsContinueButton"
            className={styles.approveButton}
            sx={{ height: "50px" }}
            onClick={handleSave}
            loading={previewImageLoading}
          >
            {" "}
            Upload Signature
          </LoadingButton>
        </div> */}
      </div>
    </div>
  );
};

export default SignaturePadNew;
